import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

import { getOrderSimple } from '../../../../actions/orders'

// Components
import Extent from '../../../components/Extent'
import SparePartList from '../../../../pages/Orders/Order/NewWorkCard/SpareParts/List'

// Elements
import Grid from '../../../elements/grid'
import Label from '../../../elements/label'
import Radio from '../../../elements/radio'
import Divider from '../../../elements/divider'
import TableRow from '../../../elements/tableRow'
import BottomBar from '../../../elements/bottomBar'
import TableExpand from '../../../elements/tableExpand'
import TableHeader from '../../../elements/tableHeader'
import TableContainer from '../../../elements/tableContainer'
import OverlayContent from '../../../elements/overlayContent'

// Utils
import { translation } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'
import { formatCurrency2 } from '../../../../utils/currency'

import './matching.scss'

class Matching extends Component {
  constructor (props) {
    super(props)
    this.state = {
      targets: [],
      sources: [],
      selectedTarget: undefined,
      selectedSource: undefined,
      orderItems: {}
    }

    this.resetMatch = this.resetMatch.bind(this)
    this.handleMatch = this.handleMatch.bind(this)
    this.renderTargets = this.renderTargets.bind(this)
    this.renderSources = this.renderSources.bind(this)
    this.checkForPropChanges = this.checkForPropChanges.bind(this)
    this.handleCancallation = this.handleCancallation.bind(this)
  }

  componentDidMount () {
    this.checkForPropChanges()
  }

  componentDidUpdate () {
    this.checkForPropChanges()
  }

  checkForPropChanges () {
    if (!isEqual(this.props.targets, this.state.targets)) {
      this.setState({ targets: this.props.targets })
    }

    if (!isEqual(this.props.sources, this.state.sources)) {
      this.setState({ sources: this.props.sources })
    }

    if (!isEqual(this.props.sources, this.state.sources) || !isEqual(this.props.targets, this.state.targets)) {
      this.resetMatch()

      let orderIds = [...this.props.targets, ...this.props.sources]
      for (var i = 0; i < orderIds.length; i++) {
        // Get data for the  missing orders
        var orderId = orderIds[i].OrderId
        if (this.state.orderItems[orderId] === undefined) {
          this.props.getOrderSimple(orderId).then(res => {
            this.setState({
              orderItems: {
                ...this.state.orderItems,
                [res.data.Id]: res.data
              }
            })
          })
        }
      }
    }
  }

  handleMatch () {
    let data = {
      TargetOrderId: this.state.selectedTarget,
      SourceOrderId: this.state.selectedSource
    }
    this.props.onMatch(data)
  }

  handleCancallation () {
    this.props.onCancallation(this.state.selectedSource)
  }

  resetMatch () {
    this.setState({
      selectedTarget: undefined,
      selectedSource: undefined
    })
  }

  renderLinePair (langKey, value) {
    return [
      <Label key={0}>{translation(langKey).replace(':', '')}:</Label>,
      <Label key={1}>{value}</Label>
    ]
  }

  renderSectionExpander (title, children) {
    return (
      <div className='grid-span-2' onClick={e => e.stopPropagation()}>
        <TableContainer>
          <TableExpand>
            <TableHeader cols='1fr min-content'>
              <Label>{title}</Label>
            </TableHeader>
            <TableRow cols='1fr'>
              {children}
            </TableRow>
          </TableExpand>
        </TableContainer>
      </div>
    )
  }

  renderTargets () {
    let { targets, selectedTarget } = this.state
    let { isLoading } = this.props

    const renderItem = (item, index) => {
      let { OrderId, CreationDate, Price, CreatedBy, BookedBy, StepDictionaryKey, RekvNumber } = item
      let isSelected = OrderId === selectedTarget
      let showBodyExtent = this.props.auth.departmentType === 1
      let orderItem = this.state.orderItems[OrderId]
      let orderItemHasSpareParts = orderItem && ((Array.isArray(orderItem.NewSparePartItems) && orderItem.NewSparePartItems.length > 0) || (Array.isArray(orderItem.SparePartItems) && orderItem.SparePartItems.length > 0))

      const onSelect = _ => this.setState({ selectedTarget: OrderId })

      return (
        <Grid
          key={index}
          cols='min-content 1fr'
          className={`order__item`}
          onClick={onSelect}>
          <Radio
            size='l'
            labelText=''
            onClick={onSelect}
            checked={isSelected}
          />
          <Grid cols='auto 1fr' className='item-content'>
            {this.renderLinePair(294, `${OrderId}`)}
            {this.renderLinePair(13387, renderFullDate(CreationDate))}
            {this.renderLinePair(641, formatCurrency2(Price))}
            {this.renderLinePair(946, StepDictionaryKey)}
            {this.renderLinePair(263, CreatedBy)}
            {this.renderLinePair(13011, BookedBy)}
            {this.renderLinePair(1337, RekvNumber)}
          </Grid>
          {showBodyExtent && this.renderSectionExpander(14779,
            orderItem && <Extent
              order={orderItem}
              department={1}
              getPrices
              extents={[{
                type: 'base',
                editable: false,
                noTitle: true
              }, {
                type: 'addon',
                editable: false,
                noTitle: true
              }]}
            />
          )}
          {this.renderSectionExpander(253,
            orderItem && <Extent
              order={orderItem}
              department={0}
              getPrices
              extents={[{
                type: 'base',
                editable: false,
                noTitle: true
              }, {
                type: 'addon',
                editable: false,
                noTitle: true
              }]}
            />
          )}
          {orderItemHasSpareParts && this.renderSectionExpander(17926,
            <SparePartList order={orderItem} />
          )}
        </Grid>
      )
    }

    return (
      <div className='col_content'>
        <Label>{683}</Label>
        {isLoading && <div className='spinner'><div className='fa fa-spinner fa-spin fa-3x fa-fw' /></div>}
        {!isLoading && targets.length === 0 && <span>{translation('18083')}</span>}
        {!isLoading && targets.map(renderItem)}
      </div>
    )
  }

  renderSources () {
    let { sources, selectedSource } = this.state
    let { isLoading } = this.props

    const renderItem = (item, index) => {
      let { OrderId, CurrentReportUid, CurrentReportVersionText, CreationDate, Price } = item
      let isSelected = OrderId === selectedSource
      let showBodyExtent = this.props.auth.departmentType === 1
      let orderItem = this.state.orderItems[OrderId]
      let orderItemHasSpareParts = orderItem && ((Array.isArray(orderItem.NewSparePartItems) && orderItem.NewSparePartItems.length > 0) || (Array.isArray(orderItem.SparePartItems) && orderItem.SparePartItems.length > 0))

      const onSelect = _ => this.setState({ selectedSource: OrderId })

      return (
        <Grid
          key={index}
          cols='min-content 1fr'
          className={`report__item`}
          onClick={onSelect}>
          <Radio
            size='l'
            labelText=''
            onClick={onSelect}
            checked={isSelected}
          />
          <Grid cols='auto 1fr' className='item-content'>
            {this.renderLinePair(14900, CurrentReportUid + (CurrentReportVersionText || ''))}
            {this.renderLinePair(13387, renderFullDate(CreationDate))}
            {this.renderLinePair(641, formatCurrency2(Price))}
          </Grid>
          {showBodyExtent && this.renderSectionExpander(14779,
            orderItem && <Extent
              order={orderItem}
              department={1}
              getPrices
              extents={[{
                type: 'base',
                editable: false,
                noTitle: true
              }]}
            />
          )}
          {this.renderSectionExpander(253,
            orderItem && <Extent
              order={orderItem}
              department={0}
              getPrices
              extents={[{
                type: 'base',
                editable: false,
                noTitle: true
              }]}
            />
          )}
          {orderItemHasSpareParts && this.renderSectionExpander(17926,
            <SparePartList order={orderItem} />
          )}
        </Grid>
      )
    }

    return (
      <div className='col_content'>
        <Label>{436}</Label>
        {isLoading && <div className='spinner'><div className='fa fa-spinner fa-spin fa-3x fa-fw' /></div>}
        {!isLoading && sources.length === 0 && <span>{translation('18084')}</span>}
        {!isLoading && sources.map(renderItem)}
      </div>
    )
  }

  render () {
    let { selectedTarget, selectedSource } = this.state
    let pairSelected = selectedTarget && selectedSource
    let showBottomBar = selectedSource

    return (
      <OverlayContent>
        {showBottomBar && <BottomBar
          actionLabelText={translation(pairSelected ? 16588 : 18082)}
          onActionClick={pairSelected ? this.handleMatch : this.handleCancallation}
          cancelLabelText={translation(1155)}
          onCancelClick={this.resetMatch}
          center
        />}

        <div className='content'>
          <div className='content-grid'>
            {this.renderSources()}
            <Divider vertical />
            {this.renderTargets()}
          </div>
        </div>
      </OverlayContent>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getOrderSimple
})(Matching)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/ReportMerge/matching/index.js